export default "__VITE_ASSET__B_X6mnBE__"